import React, { useEffect, useState } from "react";
import axios from "axios";

const COLORS = [
  "#4CAF50", // Event Payment Done
  "#2196F3", // Task Completed
  "#FFC107", // Registration Requested
  "#F44336", // Account Created
];

const radius = 60;
const strokeWidth = 20;
const center = 75;
const circumference = 2 * Math.PI * radius;

const PointsByReasonChart = () => {
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let accessToken;
    if (localStorage.user) {
      const JSToken = JSON.parse(localStorage.user);
      accessToken = JSToken.access_token;
    }

    axios
      .get(`${window.$domain}/api/method/get_points_breakdown_by_reason`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((res) => {
        setPoints(res.data.message || []);
      })
      .catch((err) => {
        console.error("Failed to fetch points data", err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-sm text-gray-500">Loading...</p>;

  const total = points.reduce((sum, item) => sum + (item.total || 0), 0);

  let offset = 0;

  return (
    <div className="bg-white rounded-xl shadow-md p-6 max-w-lg w-full">
      <h2 className="text-lg font-semibold mb-4 text-gray-800">Credit Distribution by Reason</h2>
      <div className="flex items-center justify-between gap-6">
        <svg width="150" height="150" viewBox="0 0 150 150" className="shrink-0">
          <circle
            cx={center}
            cy={center}
            r={radius}
            stroke="#f3f4f6"
            strokeWidth={strokeWidth}
            fill="none"
          />
          {points.map((item, index) => {
            const value = item.total || 0;
            const percent = value / total;
            const dash = percent * circumference;

            const circle = (
              <circle
                key={index}
                cx={center}
                cy={center}
                r={radius}
                stroke={COLORS[index % COLORS.length]}
                strokeWidth={strokeWidth}
                fill="none"
                strokeDasharray={`${dash} ${circumference - dash}`}
                strokeDashoffset={-offset}
                strokeLinecap="round"
              />
            );

            offset += dash;
            return circle;
          })}
          <text
            x={center}
            y={center}
            textAnchor="middle"
            dominantBaseline="central"
            className="fill-gray-700 text-base font-semibold"
          >
            ${ (total / 100).toFixed(2) }
          </text>
        </svg>

        <div className="flex-1 space-y-3">
          {points.map((item, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span
                  className="inline-block w-3 h-3 rounded-full"
                  style={{ backgroundColor: COLORS[index % COLORS.length] }}
                ></span>
                <span className="text-sm text-gray-700">{item.reason}</span>
              </div>
              <span className="text-sm font-medium text-gray-900">
                ${ (item.total / 100).toFixed(2) }
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PointsByReasonChart;
